export const AllFHIRRequestTemplates = [
    {
        label: 'Fetch',
        requestType: 'fetch',
        resourceType: 'Encounter',
        content: {
            resource: 'EncounterResource'
        }
    },
    {
        label: 'DocumentReference.Create',
        resourceType: 'DocumentReference',
        requestType: 'create',
        content: {
            content: '',
            docStatus: 'final',
            noteTypeCode: '34117-2',
            noteDisplay: 'H&P Note',
        }
    }
];
//# sourceMappingURL=templates.js.map